var render = function render(){
  var _vm$selectedItem, _vm$selectedItem2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-4"
  }, [_c('HeaderDetailItemSR', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "optionsTaskType": _vm.optionsTaskType,
      "optionsDepartment": _vm.optionsDepartment,
      "optionsCategory": _vm.optionsCategory,
      "optionsClassification": _vm.optionsClassification,
      "optionsCause": _vm.optionsCause,
      "optionsKindTask": _vm.optionsKindTask
    }
  }), _c('b-row', [_c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "lg": "12"
    }
  }, [_c('CustomNav', {
    attrs: {
      "items": _vm.tabs
    },
    on: {
      "item-click": function itemClick(val) {
        return _vm.activeTab = val;
      }
    }
  })], 1), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "lg": "12"
    }
  }, [_vm.activeTab == 1 ? [_c('ListInternalManPower', {
    attrs: {
      "data": (_vm$selectedItem = _vm.selectedItem) === null || _vm$selectedItem === void 0 ? void 0 : _vm$selectedItem.internal_manpower,
      "formRepairId": _vm.selectedItem.id
    }
  })] : _vm._e(), _vm.activeTab == 2 ? [_c('ListSubContractor', {
    attrs: {
      "data": (_vm$selectedItem2 = _vm.selectedItem) === null || _vm$selectedItem2 === void 0 ? void 0 : _vm$selectedItem2.subcons
    }
  })] : _vm._e()], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }